import { getStyles as e } from "./style.js";
import { cn as t } from "../../cn.js";
import { FormErrorText as n, FormHelperText as r, FormLabel as i } from "../shared/form-primitives.js";
import { ChevronDownIcon as a, ChevronUpIcon as o } from "lucide-react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { Field as l } from "@ark-ui/react";
import { NumberInput as u } from "@ark-ui/react/number-input";
// src/design/forms/number-input/index.tsx
var d = (e) => {
	let t = {}, n = {};
	for (let [r, i] of Object.entries(e)) r.startsWith("aria-") ? t[r] = i : n[r] = i;
	return {
		aria: t,
		rest: n
	};
}, f = ({ label: f, helperText: p, errorText: m, config: h, className: g, disabled: _, required: v, invalid: y, placeholder: b, id: x, autoComplete: S, autoFocus: C, onFocus: w, onBlur: T, onKeyDown: E, inputProps: D, ...O }) => {
	let k = e(h), A = !!m || y, { aria: j, rest: M } = d(O), { className: N, ...P } = D ?? {}, F = {
		...j,
		autoComplete: S,
		autoFocus: C,
		onFocus: w,
		onBlur: T,
		onKeyDown: E,
		placeholder: b,
		className: t(k.input(), N),
		...P
	};
	return /* @__PURE__ */ s(l.Root, {
		invalid: A,
		required: v,
		disabled: _,
		children: /* @__PURE__ */ c(u.Root, {
			className: t(k.root({ disabled: _ }), g),
			invalid: A,
			required: v,
			disabled: _,
			ids: x ? { input: x } : void 0,
			...M,
			children: [
				f && /* @__PURE__ */ s(i, {
					disabled: _,
					required: v,
					htmlFor: x,
					children: f
				}),
				/* @__PURE__ */ c(u.Control, {
					className: k.control(),
					children: [/* @__PURE__ */ s(u.Input, { ...F }), /* @__PURE__ */ c("div", {
						className: k.triggerGroup(),
						children: [/* @__PURE__ */ s(u.IncrementTrigger, {
							className: t(k.trigger(), k.incrementTrigger()),
							children: /* @__PURE__ */ s(o, { size: 16 })
						}), /* @__PURE__ */ s(u.DecrementTrigger, {
							className: t(k.trigger(), k.decrementTrigger()),
							children: /* @__PURE__ */ s(a, { size: 16 })
						})]
					})]
				}),
				p && !m && /* @__PURE__ */ s(r, { children: p }),
				m && /* @__PURE__ */ s(n, { children: m })
			]
		})
	});
}, p = Object.assign(f, {
	Default: f,
	Root: ({ children: n, className: r, config: i, ...a }) => {
		let o = e(i), { disabled: c, required: d, invalid: f, id: p } = a;
		return /* @__PURE__ */ s(l.Root, {
			className: t(o.root({ disabled: c }), r),
			disabled: c,
			required: d,
			invalid: f,
			id: p,
			children: /* @__PURE__ */ s(u.Root, {
				className: o.root({ disabled: c }),
				...a,
				children: n
			})
		});
	},
	Label: ({ children: e, required: t, disabled: n, ...r }) => /* @__PURE__ */ s(i, {
		required: t,
		disabled: n,
		...r,
		children: e
	}),
	Control: ({ children: n, className: r, config: i, ...a }) => {
		let o = e(i);
		return /* @__PURE__ */ s(u.Control, {
			className: t(o.control(), r),
			...a,
			children: n
		});
	},
	Input: ({ className: n, config: r, ...i }) => {
		let a = e(r);
		return /* @__PURE__ */ s(u.Input, {
			className: t(a.input(), n),
			...i
		});
	},
	IncrementTrigger: ({ children: n, className: r, config: i, ...a }) => {
		let c = e(i);
		return /* @__PURE__ */ s(u.IncrementTrigger, {
			className: t(c.trigger(), c.incrementTrigger(), r),
			...a,
			children: n ?? /* @__PURE__ */ s(o, { size: 16 })
		});
	},
	DecrementTrigger: ({ children: n, className: r, config: i, ...o }) => {
		let c = e(i);
		return /* @__PURE__ */ s(u.DecrementTrigger, {
			className: t(c.trigger(), c.decrementTrigger(), r),
			...o,
			children: n ?? /* @__PURE__ */ s(a, { size: 16 })
		});
	},
	HelperText: ({ children: e, ...t }) => /* @__PURE__ */ s(r, {
		...t,
		children: e
	}),
	ErrorText: ({ children: e, ...t }) => /* @__PURE__ */ s(n, {
		...t,
		children: e
	}),
	ValueText: ({ className: n, config: r, ...i }) => {
		let a = e(r);
		return /* @__PURE__ */ s(u.ValueText, {
			className: t(a.valueText(), n),
			...i
		});
	},
	Scrubber: ({ className: n, config: r, ...i }) => {
		let a = e(r);
		return /* @__PURE__ */ s(u.Scrubber, {
			className: t(a.scrubber(), n),
			...i
		});
	},
	getStyles: e
});
export { p as NumberInput };

//# sourceMappingURL=index.js.map